<template>
  <div class="headlines" :class="color">
    <h3 v-html="kicker" />
    <h2 v-html="headline" />
  </div>
</template>

<script>
  export default {
    name: "Headline",
    props: {
      kicker: {
        type: String
      },
      headline: {
        type: String
      },
      color: {
        type: String,
        default () {
          return 'blue';
        }
      }
    }
  }
</script>

<style scoped>
  .blue {
    color: #102D61;
  }
  .white {
    color: white;
  }
  .white h3:after {
    background-color: white;
  }
  h3 {
    position: relative;
    display: inline-block;
    font-weight: 500;
    font-size: 18px;
    padding-bottom: 3px;
    margin: 0;
  }
  h3:after {
    content: "";
    position: absolute;
    display: block;
    left: 0;
    right: 0;
    bottom: 0;
    height: 3px;
    background-color: #102D61;
    border-radius: 3px;
  }
  h2 {
    position: relative;
    font-size: 36px;
    line-height: 1.2;
    font-weight: 700;
    margin: 0.3em -0.04em;
  }
  @media(max-width: 767px) {
    h3 {
      font-size: 15px;
    }
    h3:after {
      height: 2px;
    }
    h2 {
      font-size: 28px;
    }
  }
  @media (max-width: 480px) {
    h2 {
      font-size: 8vw;
    }
  }
</style>